import { addDisposableEventListener, useElementOrFindIt } from '../core';
import { CLASSES, SELECTORS } from './constants';

export interface LeftNavLayoutOptions {
  layoutRoot: Element;
  collapse?: Element;
}

export class LeftNavLayout {
  private __domElements: LeftNavLayoutOptions;
  private __destroyListeners?: () => void;
  /**
   *
   * @param {object} options
   * @param {Element} options.layoutRoot
   * @param {Element|null} [options.collapse]
   */
  constructor(options: LeftNavLayoutOptions) {
    this.__initElements(options);

    // collapse functionality is optional
    if (this.__domElements.collapse) {
      this.__destroyListeners = addDisposableEventListener(
        this.__domElements.collapse,
        'click',
        this.__handleCollapse.bind(this)
      );
    }
  }

  destroy(): void {
    this.__domElements = null;
    if (this.__destroyListeners) {
      this.__destroyListeners();
    }
  }

  private __handleCollapse() {
    const layoutRoot = this.__domElements.layoutRoot;
    if (layoutRoot) {
      layoutRoot.classList.toggle(CLASSES.closedClass);
    }
  }

  private __initElements(options: LeftNavLayoutOptions) {
    const layoutRoot = options.layoutRoot;
    // ignore collapse if layout root is not provided
    const collapseBtn = layoutRoot
      ? useElementOrFindIt(options.collapse, {
          parent: layoutRoot,
          selector: SELECTORS.collapse,
        })
      : null;
    this.__domElements = {
      layoutRoot,
      collapse: collapseBtn,
    };
  }
}
